import { render, staticRenderFns } from "./OpenidForm.vue?vue&type=template&id=1905c1cd&scoped=true"
import script from "./OpenidForm.vue?vue&type=script&lang=js"
export * from "./OpenidForm.vue?vue&type=script&lang=js"
import style0 from "./OpenidForm.vue?vue&type=style&index=0&id=1905c1cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905c1cd",
  null
  
)

export default component.exports